import { EventCategory, LocationType } from '@/types/events';

export const EVENT_TYPES: { value: EventCategory; label: string }[] = [
  { value: 'workshop', label: 'Workshop' },
  { value: 'seminar', label: 'Seminar' },
  { value: 'social', label: 'Social Event' },
  { value: 'meeting', label: 'Meeting' },
  { value: 'training', label: 'Training' }
];

export const LOCATION_TYPES: { value: LocationType; label: string }[] = [
  { value: 'physical', label: 'Physical' },
  { value: 'virtual', label: 'Virtual' },
  { value: 'hybrid', label: 'Hybrid' }
];